import * as React from "react";
import RoleList from "src/components/RoleList";
import RolesQuery from "src/queries/RolesQuery";

export default () => (
  <RolesQuery>
    {({ loading, error, data }) => {
      if (!data) {
        return null;
      }
      if (error) {
        return <h1>ERROR</h1>;
      }
      return <RoleList roles={data.roles} loading={loading} />;
    }}
  </RolesQuery>
);



// WEBPACK FOOTER //
// ./src/screens/Roles/RolesPage.tsx